import { useLocation } from 'react-router-dom';

import { useTodaysCountry } from '../providers/TodaysCountryProvider';
import { useUser } from '../providers/UserProvider';
import { GoogleMapsAndWikipediaButtons } from './buttons/GoogleMapsAndWikipediaButtons';
import { NextBonusRoundButton } from './NextBonusRoundButton';
import { ArchiveButton } from './PlayArchiveButton';
import { ReplayButton } from './ReplayButton';
import { ShareButton } from './ShareButton';

export const RoundEndedButtons = ({
  nextBonusRoundIndex,
}: {
  nextBonusRoundIndex?: number;
}) => {
  const location = useLocation();
  const { todaysCountry } = useTodaysCountry();
  const { userDetails } = useUser();

  const showArchiveButton =
    userDetails &&
    userDetails?.premiumGames?.includes('flagle') &&
    !location.pathname.includes('archive');

  return (
    <div className="flex flex-col w-full gap-4 justify-center items-center">
      <div className="flex w-full gap-4 justify-center items-center">
        <GoogleMapsAndWikipediaButtons country={todaysCountry} />
        <ShareButton />
      </div>
      {nextBonusRoundIndex !== undefined ? (
        <div className="flex flex-col md:flex-row gap-4 w-full justify-center items-center">
          {showArchiveButton && <ArchiveButton />}
          <NextBonusRoundButton nextBonusRoundIndex={nextBonusRoundIndex} />
        </div>
      ) : (
        <div className="flex flex-col md:flex-row gap-4 w-full justify-center items-center">
          <ReplayButton />
          <ArchiveButton />
        </div>
      )}
    </div>
  );
};
